import { Locale } from 'modules/i18n';

export const chainProjectItemTranslation = {
  [Locale.en]: {
    addToProject: 'Add to project',
    codeExample: 'Code example',
    defaultName: 'Default',
    requestsTitleMobile: 'Requests ({timeframe})',
  },
};
